import { create } from "zustand";
import { persist } from "zustand/middleware";

interface WorkspaceStore {
  selectedOrganizationId: string | null;
  setSelectedOrganizationId: (organizationId: string | null) => void;
  selectedBrandId: string | null;
  setSelectedBrandId: (brandId: string | null) => void;
  _hasHydrated: boolean;
  setHasHydrated: (hasHydrated: boolean) => void;
}

const WORKSPACE_STORAGE_KEY = "workspace-store";

export const useWorkspaceStore = create<WorkspaceStore>()(
  persist(
    (set) => ({
      selectedOrganizationId: null,
      setSelectedOrganizationId: (organizationId: string | null) =>
        set({ selectedOrganizationId: organizationId }),
      selectedBrandId: null,
      setSelectedBrandId: (brandId: string | null) =>
        set({ selectedBrandId: brandId }),
      _hasHydrated: false,
      setHasHydrated: (hasHydrated: boolean) =>
        set({ _hasHydrated: hasHydrated }),
    }),
    {
      name: WORKSPACE_STORAGE_KEY,
      partialize: (state) => ({
        selectedOrganizationId: state.selectedOrganizationId,
        selectedBrandId: state.selectedBrandId,
      }),
      onRehydrateStorage: () => (state, error) => {
        if (error) {
          useWorkspaceStore.setState({ _hasHydrated: true });
          return;
        }
        state?.setHasHydrated(true);
      },
    },
  ),
);

/** Clears persisted workspace data. Call on logout so the next user doesn't rehydrate the previous user's org/brand. */
export const clearWorkspaceStorage = () => {
  useWorkspaceStore.persist?.clearStorage?.();
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(WORKSPACE_STORAGE_KEY);
  }
};
